import clsx from "clsx";

import { formatNumber } from "helpers/formatNumber";
import { IFRCalculationResult } from "models/HaulPay";
import styles from "./style.module.scss";

interface IProps {
  frCalculation?: IFRCalculationResult;
}

export default function BrokerFrStatus({ frCalculation }: Readonly<IProps>) {
  const {
    contract_type: contractType,
    total_comfreight_fee: totalFee,
    factoring_fee: yourFee,
    factoring_payable: yourPay,
    self_finance_total_amount: debitAmount,
    broker_self_finance_fee: selfFinanceFee,
    self_finance_fee_rate_info: selfFinanceFeeRateInfo,
    reserve_amount: reserveAmount,
    broker_carrier_advance: brokerLineHaul,
    payment_profile_fee: brokerQPFee
  } = (frCalculation ?? {
    total_comfreight_fee: 0,
    factoring_fee: 0,
    factoring_payable: 0,
    self_finance_total_amount: 0,
    broker_self_finance_fee: 0,
    self_finance_fee_rate_info: 0,
    reserve_amount: 0,
    broker_carrier_advance: 0,
    payment_profile_fee: 0
  }) as IFRCalculationResult;

  return (
    <div className={styles.cardBoxWrapper}>
      <span className={styles.cardTitle}>Broker</span>
      <ul
        className={clsx(
          styles.cardBody,
          "desktop:!grid desktop:!gap-x-2",
          contractType?.startsWith("SELF_FINANCE") ? "desktop:!grid-cols-5" : "desktop:!grid-cols-4"
        )}>
        {contractType?.startsWith("SELF_FINANCE") ? (
          <>
            <li>
              <span className="text-xs desktop:text-sm">Line Haul</span>
              <span className="text-error">{formatNumber(brokerLineHaul / 100, 2)}</span>
            </li>
            <li>
              <span className="text-xs desktop:text-sm">Self finance fee</span>
              <div>
                <span className="text-error">{formatNumber(selfFinanceFee / 100, 2)} </span>
                <span>({selfFinanceFeeRateInfo})</span>
              </div>
            </li>
            <li>
              <span className="text-xs desktop:text-sm">Gross QP Profit</span>
              <span className="text-success">{formatNumber(brokerQPFee / 100, 2)}</span>
            </li>
            <li className="!border-none">
              <span className="text-xs desktop:text-sm mobile:text-time">Debit Amount</span>
              <span className="font-bold text-error">{formatNumber(debitAmount / 100, 2)}</span>
            </li>
            <li className="!border-none">
              <span className="text-xs desktop:text-sm mobile:text-time">Net QP Profit</span>
              <span
                className={clsx(
                  "font-bold",
                  brokerLineHaul >= debitAmount ? "text-success" : "text-error"
                )}>
                {formatNumber((brokerLineHaul - debitAmount) / 100, 2)}
              </span>
            </li>
          </>
        ) : (
          <>
            <li className={reserveAmount !== 0 ? "" : "!border-none"}>
              <span className="text-xs desktop:text-sm">Total Fee</span>
              <span className="text-error">{formatNumber(totalFee / 100, 2)}</span>
            </li>
            {reserveAmount ? (
              <li>
                <span className="text-xs desktop:text-sm">Reserve Holdback</span>
                <span className="font-bold text-error">{formatNumber(reserveAmount / 100, 2)}</span>
              </li>
            ) : null}
            <li className={reserveAmount !== 0 ? "" : "!border-none"}>
              <span className="text-xs desktop:text-sm">Your Fee</span>
              <span className="font-bold text-error">{formatNumber(yourFee / 100, 2)}</span>
            </li>
            <li className="!border-none">
              <span className="text-xs desktop:text-sm mobile:text-time">Your Pay</span>
              <span className="font-bold text-success">{formatNumber(yourPay / 100, 2)}</span>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}
